/**
 * AppLayout — Main application shell using shadcn Sidebar.
 *
 * Accepts a `shell` prop to determine which navigation lane is rendered
 * (Operations vs Admin Console). Shell is determined by the route tree
 * in App.tsx, not by internal state — ensuring zero-flicker boot.
 *
 * @see https://ui.shadcn.com/docs/components/sidebar
 */

import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/layout/AppSidebar';
import { AppHeader } from '@/components/layout/AppHeader';
import { AIChatWidget } from '@/components/ai/AIChatWidget';
import { useRouteView } from '@/hooks/useNavInstrumentation';
import type { NavShell } from '@/config/nav';

export function AppLayout({ shell = 'operations' }: { shell?: NavShell }) {
  // Fire route_view events on navigation
  useRouteView();

  return (
    <SidebarProvider>
      <AppSidebar shell={shell} />
      <SidebarInset>
        <AppHeader shell={shell} />
        <main className="min-w-0 flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-6">
          <Outlet />
        </main>
      </SidebarInset>
      <AIChatWidget />
    </SidebarProvider>
  );
}
